export default __webpack_public_path__ + "locales/cs/About.json?hash=82c10a5d4b75fb07bf46d4535773c5c5";